import { restClient } from '@/api/client'
import { endpoints } from '@/api/endpoints'

const q = (p: Record<string, unknown>) => new URLSearchParams(
  Object.entries(p).filter(([, v]) => v !== undefined && v !== null && v !== '').reduce((a, [k, v]) => ({ ...a, [k]: String(v) }), {})
).toString()

export const homeListingService = {
  list: (p: { page?: number; limit?: number; search?: string } = {}) => {
    const params: Record<string, unknown> = { page: p.page ?? 1, limit: p.limit ?? 15 }
    if (p.search) params.search = p.search
    return restClient.get(`${endpoints.homeListing.list}?${q(params)}`).then(r => r.data)
  },
  details: (id: number | string) => restClient.get(`${endpoints.homeListing.details}${id}`).then(r => r.data),
  createUpdate: (d: Record<string, unknown>) => restClient.post(endpoints.homeListing.createUpdate, d).then(r => r.data),
  delete: (id: number) => restClient.delete(`${endpoints.homeListing.delete}${id}`).then(r => r.data),
}
